'use strict';

module.exports = ValidationError;


function ValidationError(errors) {
  this.message = 'validation failed';
  this.errors = errors;
  this.ajv = this.validation = true;
}


ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;



//////////////////
// WEBPACK FOOTER
// ./~/jsoneditor/~/ajv/lib/compile/validation_error.js
// module id = 24
// module chunks = 0